import { Component, OnInit, ViewChild, Input, Output } from '@angular/core';
import { PoModalComponent, PoTableColumn, PoDynamicFormField, PoModalAction, PoNotificationService, PoI18nService } from '@po-ui/ng-components';
import { FormGroup, NgForm } from '@angular/forms';
import { EventEmitter } from '@angular/core';
import { UtilService } from 'src/app/services/util-service/util.service';

@Component({
  selector: 'app-modal-filter',
  templateUrl: './modal-filter.component.html',
  styleUrls: ['./modal-filter.component.css']
})
export class ModalFilterComponent implements OnInit {

  constructor(
    private notification: PoNotificationService,
    private utilService: UtilService,
  ) { }

  tableHeight;

  /** Table */

  // Colunas da tabela
  @Input() tableColumns: PoTableColumn[];

  // Itens da tabela
  @Input() tableItems: any;

  // Numero total de itens da tabela
  @Input() totalItems: any;

  // Loading da tabela
  @Input() tableLoading: boolean;

  // Numero de itens por pagina
  @Input() itemsPerPage: any;

  //habilita um único select se true, e multiselect se false
  @Input() singleSelect: boolean = true;

  // Pagina atual
  currentPage = 1;

  // Emite o item selecionado
  @Output() selectedItem: EventEmitter<any> = new EventEmitter();
  item: any[] = []

  // Emite a pagina ao mudar
  @Output() pageChanged: EventEmitter<any> = new EventEmitter();

  /** Filter */
  @Input() filters: PoDynamicFormField;
  @Output() filterOutput: EventEmitter<any> = new EventEmitter();

  // visibilidade de paginação
  @Input() visibilidade: boolean;

  // visibilidade Formulário de Busca
  @Input() visibilidadeBusca: boolean;

  // Fecha o Modal
  @Output() closeModal = new EventEmitter();

  form: NgForm;
  // literals: ModalFilterI18n


  /** Modal */
  modalForm: FormGroup; // form
  @ViewChild('modalFilter', { static: true }) modalFilter: PoModalComponent;
  @Input() modalTitle: string;
  modalPrimaryAction: PoModalAction = {
    label: 'Selecionar', action: () => {
      if (this.item.length < 1 || this.item === []) {
        this.notification.warning('Selecione um item');
        return;
      } else {
        this.selectedItem.emit(this.item);
        this.item = [];
        // this.form.resetForm();
        this.modalFilter.close();
      }
    }
  };
  modalSecondaryAction: PoModalAction = {
    label: 'Fechar', action: () => {
        this.closeModal.emit(this.item);
        this.modalFilter.close();
      // }
    }
  };

  ngOnInit() {
    this.tableHeight = this.utilService.calcularHeight(window.innerHeight, 0.40);
    this.visibilidade == undefined ? this.visibilidade = true : this.visibilidade = this.visibilidade;
    this.visibilidadeBusca == undefined ? this.visibilidadeBusca = true : this.visibilidadeBusca = this.visibilidadeBusca;
  }

  onPageChange(page) {
    this.currentPage = page;
    this.form.value.page = this.currentPage;
    this.pageChanged.emit(this.form.value);
  }

  // Seleciona o item
  selected(event: any) {
    if (this.singleSelect === true) {
      this.item = [];
      this.item = event;
      return this.item;
    } else {
      this.item.push(event);
    }
    return this.item;
  }

  //desmarcar linha
  unSelected(event: any) {
    this.item = this.arrayRemove(this.item, event);
  }

  // função que complementa a desmarcar função
  arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele != value;
    });
  }

  // marcar todas as linhas
  allSelected(event: any) {
    let current: Array<any> = this.item;
    this.item = current.concat(...event);
    return this.item;
  }

  // desmarcar todas as linhas
  unAllSelected(event: any) {
    this.item = [];
  }

  returnForm() {
    this.currentPage = 1;
    this.form.value.page = this.currentPage;
    this.filterOutput.emit(this.form.value);
  }
  getForm(form: NgForm) {
    this.form = form;
  }
  open() {
    this.modalFilter.size = 'xl';
    this.modalFilter.open();
  }
}
